import 'reflect-metadata'
import ContactModel from '@models/contact'
import BaseComponent from '@base/component'
import { makeUrl } from '@utils/query'
import { createApp, defineComponent } from 'vue'
import ErrorsComponentVue from '@components/errors/errors.vue'
import MsgsComponentVue from '@components/msgs/msgs.vue'

var model = new ContactModel()

var component = defineComponent({
    mixins: [BaseComponent],
    components: {
        errors: ErrorsComponentVue,
        msgs: MsgsComponentVue
    },
    data() {
        return {
            model
        }
    },
    methods: {
        submit: function (evt) {
            evt.preventDefault();
            this.model.busy = true;
            var data = $("form#contact_form").serializeObject();
            console.log("DATA",data);
            this.model.recaptcha = data['g-recaptcha-response'];
            this.model.sync("submit", () => this.model.busy = false);
            return false;
        }
    }
});

model.fetchData().then(data => {
    const app = createApp(component)
    app.mount("section#contact")
});
